import { render, staticRenderFns } from "./RelatedDocumentsDetailsActions.vue?vue&type=template&id=b0fc4e2e&scoped=true"
import script from "./RelatedDocumentsDetailsActions.vue?vue&type=script&lang=ts"
export * from "./RelatedDocumentsDetailsActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fc4e2e",
  null
  
)

export default component.exports